const sanitizeHtml = require('sanitize-html');

function unescapechars(s){
   //Undoes stupid html escaping from sanitize-html lib
   return s.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
}
module.exports = {
  sanitize: function(string) {
    if (!string){
      return
    }
    var newstring = sanitizeHtml(string, {
      allowedTags: [],
      allowedAttributes: []
    }).trim();
    return unescapechars(newstring);
  }
};
